import React from 'react';
import { Edit, SimpleForm } from 'react-admin';

import { CustomToolbar, Grid } from '../../components'
import TenantBankAccountFields from './TenantBankAccountFields'

export const TenantBankAccountEdit = props => (
  <Edit {...props}>
    <SimpleForm toolbar={<CustomToolbar {...props} />}>
      <Grid container spacing={8}>
        <TenantBankAccountFields />
      </Grid>
    </SimpleForm>
  </Edit>
);

export default TenantBankAccountEdit
